(function() {
  function removePKR() {
    document.querySelectorAll('.boost-sd__format-currency').forEach(function(node) {
      if (node.textContent.includes('PKR')) {
        node.textContent = node.textContent.replace('PKR', '');
      }
    });
  }

  var observer = new MutationObserver(removePKR);

  document.addEventListener('DOMContentLoaded', function() {
    removePKR();
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { observer.disconnect(); }, 15000);
  });
})();
